// ** Router imports
import { useRoutes } from 'react-router-dom'
import useNoPermission from '../utility/hooks/useNoPermission'
import useNotAuthorized from '../utility/hooks/useNotAuthorized'

const Router = ({ allRoutes }) => {
  useNotAuthorized()
  useNoPermission()

  const routes = useRoutes([...allRoutes])

  return routes
}

export default Router
